import React, {useState,useEffect} from 'react';
import OtherBanner from '../components/OtherBanner';
import ImageWithText from '../components/ImageWithText';
import OurValue from '../components/OurValue';
import AllServices from '../components/AllServices';
import QuickPoint from '../components/QuickPoint';
import DownloadApp from '../components/DownloadApp';

import ServicesBanner from '../assets/img/services-banner.png';
import ServicesAbout from '../assets/img/services-about.png';
import serviceBenefitsimg from '../assets/img/benefits-img.png';
import webPortalServices from '../../services/webPortal.services';
import serviceBenefitsimg2 from '../assets/img/benefits-img2.png';


const Services = () => {
    const [pageContets, setPageContets] = useState([]);
    useEffect(()=>{
     webPortalServices.customizedData().then((res)=>{
      setPageContets(res.data.webNavMenuList)
    });
   
  },[])
  const filterServices = pageContets.filter(item => item.status === 1 && item.pageUrl ==='services');
    return (
        <>
            <OtherBanner
                image={filterServices[0]?.bannerImg ? filterServices[0]?.bannerImg : ServicesBanner}
                title={filterServices[0]?.bannerTitle ? filterServices[0]?.bannerTitle : "TESTIGO MOBILE MEDICAL DIAGNOSTICS"}
                text={filterServices[0]?.bannerText ? filterServices[0]?.bannerText : "Our service works in two ways:"}
            />
            <ImageWithText
                class="services-about"
                image={ServicesAbout}
                smallHeading= {`${filterServices[0]?.sectionOneSmallHeadin ? filterServices[0]?.sectionOneSmallHeadin:'About Us'}`} 
                heading={`${filterServices[0]?.sectionOneHeading ?filterServices[0]?.sectionOneHeading:'1. On Demand X-ray Service'}`}
                para={`${filterServices[0]?.sectionOneParagraph ? filterServices[0]?.sectionOneParagraph:'We are the only fully licensed mobile radiology service in Ireland. Our mantra is moving equipment not patients and our mission is to bring quality care and diagnostics to communities in a clinically compliant manner. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries'}`}
            />
            <OurValue
                pageName="service"
            />
            <AllServices />
            <ImageWithText
                class="service-banifits"
                image={serviceBenefitsimg}
                smallHeading="Our Benefits"
                heading="2. On-site X-ray Department"
                para="We are the only fully licensed mobile radiology service in Ireland. Our mantra is moving equipment not patients and our mission is to bring quality care and diagnostics to communities in a clinically compliant manner. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries."
            />
            <ImageWithText
                class="service-banifits2"
                image={serviceBenefitsimg2}
                smallHeading="Benefits"
                heading="The benefits of our service"
                para="We are the only fully licensed mobile radiology service in Ireland. Our mantra is moving equipment not patients and our mission is to bring quality care and diagnostics to communities in a clinically compliant manner. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries."
            />
            <QuickPoint
                text="Moving equipment not patients. For more information call us"
                phoneNo="087 056 4412"
            />
            <DownloadApp />
        </>
    );
};

export default Services;